import request from '../utils/request';
export function fetchBioPage() {
    return request()
        .get('/api/v1/bio-page/')
        .send();
}
